export function map(func) {
  return function(arr) {
    return (Array.isArray(arr) && arr.map(func)) || [];
  };
}

export function sum(arr) {
  return arr.reduce((a, b) => a + b, 0);
}

/**
* 解析url参数
* @param {String} name 参数名
* @return {String} 值
*/
export function getQueryString(name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return window.decodeURI(r[2]);

  return null;
}

/**
 * 裁图
 * @param {*} imageUrl 
 * @param {*} WH widthxheight eg: 120x120
 */
export function cropImage(imageUrl, width = '', height = '') {
  // Doc: https://cloud.tencent.com/document/api/460/6929
  if (!width || !height) {
    return imageUrl;
  }
  return `${imageUrl}?imageView2/5/w/${width}/h/${height}`;
}


const isEmpty = (o) => o === undefined || o === null;

/**
 * comma
 */
const stringifyArray = (key, value, format='comma') => {
    if (value.length > 0) {
        return key + '=' + value.join(',')
    }

    return key + '='
}

export const encodeQueryString = (obj) => {
  const pairs = [];
  Object.keys(obj).forEach(key => {
    if (!isEmpty(obj[key])) {

        if (Array.isArray(obj[key])) {
            pairs.push(stringifyArray(key, obj[key]))
            return
        }

        pairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    }
    });
  return pairs.join('&');
};

export function toFen(yuan = 0) {
  /**
   * REVIEW
   * 2341.8 * 100 => 234180.00000000003
   */
  // return yuan * 100
  return Math.round(yuan * 100)
}


